<h1 mat-dialog-title>{{ data.message }}</h1>
<mat-dialog-content>
  @if (errorMessage) {
    <div class="error">{{ errorMessage }}</div>
  }
  <div [@detailExpand]="showDetails ? 'expanded' : 'collapsed'">
    <pre class="details">{{ formattedData }}</pre>
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  @if (showDetails) {
    <button mat-button [cdkCopyToClipboard]="formattedData" i18n>
      <mat-icon>content_copy</mat-icon>&nbsp;Copy details
    </button>
  } @else {
    <button mat-button (click)="showDetails = true" i18n>
      Show details
    </button>
  }
  <button mat-flat-button cdkFocusInitial [mat-dialog-close]="true" i18n>Close</button>
</mat-dialog-actions>
